<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '3px'}" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
    <div class="content-wrapper">
        <div class="content-detached">
            <div class="content-body">
                <div class="row">
                    <div class="col-12">
                        <app-emisor-bhe></app-emisor-bhe>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-5">
                        <app-receptor-bhe></app-receptor-bhe>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-5">
                        <app-prestaciones-bhe></app-prestaciones-bhe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>